import { render } from "./categoryComponent.vue?vue&type=template&id=6b7d674e&scoped=true"
import script from "./categoryComponent.vue?vue&type=script&lang=js"
export * from "./categoryComponent.vue?vue&type=script&lang=js"

import "./categoryComponent.vue?vue&type=style&index=0&id=6b7d674e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7d674e"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/categoryComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b7d674e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b7d674e', __exports__)) {
    api.reload('6b7d674e', __exports__)
  }
  
  module.hot.accept("./categoryComponent.vue?vue&type=template&id=6b7d674e&scoped=true", () => {
    api.rerender('6b7d674e', render)
  })

}


export default __exports__